export default __webpack_public_path__ + "static/media/AlecMitrokostasResume.43af5ebe.pdf";